window.SiteReady(($) => {

  console.log('Init Block: Accordion');

  $('.js-accordion_item').on('swap:activate', (e) => {
    setTimeout(() => {
      let $target = $(e.currentTarget);

      window.scrollToElement( $target );
    }, 1);
  });

});